import { getApiData, postFormData } from "../utils/APIHelper";

const DESIGN_ENDPOINTS = {
  GET_PROJECT_FILES: (projectId, tag) =>
    `api/project/files/${projectId}?type=project&tags=${tag}`,
  UPLOAD_PROJECT_FILES: () => `api/project/files`,
  DELETE_PROJECT_FILE: (imageId) => `api/project/delete-files/${imageId}`,
};

/**
 * Fetch all project files filtered by a tag (e.g. ELEVATION, FLOORPLAN_AS_BUILT).
 */
export const getDesignFiles = async (projectId, tag) => {
  try {
    const response = await getApiData(
      DESIGN_ENDPOINTS.GET_PROJECT_FILES(projectId, tag),
      "GET",
      {}
    );
    return response;
  } catch (error) {
    console.error("Error fetching design files:", error);
    throw error;
  }
};

/**
 * Upload one or more files for a given tag.
 * Mirrors portal payload: project_id + type=project + tags=<tag> + file_1..file_n keys.
 */
export const uploadDesignFiles = async (projectId, files, tag) => {
  try {
    const formData = new FormData();
    formData.append("project_id", projectId);
    formData.append("type", "project");
    formData.append("tags", tag);
    Array.from(files).forEach((file, i) => {
      formData.append(`file_${i + 1}`, file);
    });
    const response = await postFormData(
      DESIGN_ENDPOINTS.UPLOAD_PROJECT_FILES(),
      formData
    );
    return response;
  } catch (error) {
    console.error("Error uploading design files:", error);
    throw error;
  }
};

/**
 * Delete a single project file by id (POST per portal contract).
 */
export const deleteDesignFile = async (imageId) => {
  try {
    const response = await getApiData(
      DESIGN_ENDPOINTS.DELETE_PROJECT_FILE(imageId),
      "POST",
      {}
    );
    return response;
  } catch (error) {
    console.error("Error deleting design file:", error);
    throw error;
  }
};
